// extracted by mini-css-extract-plugin
export default {"infoActions":"EditManagerActions_infoActions__-6bpJ","infoButton":"EditManagerActions_infoButton__qT-KP"};